import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import Select from 'src/common/refactoredComponents/select/Select';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import Lock from 'src/assets/images/Lock.svg';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import { logErrorToConsole } from 'src/utils/util';
import {
    getUserRoles,
    getARDTlist,
    getNewAssignment,
    updateUser,
    setUserRolechange,
    resetARDTList,
    setArea,
} from 'src/pages/admin/redux/action';
import {
    OrderDetailTabBody,
    MainDiv,
    Heading,
    SubHeading,
    Container2,
    Box,
    SalesMainDiv,
    SalesDiv,
    RoleBox,
    ImgDiv,
    ButtonDiv,
    OrderSalesMobile,
    DesktopView,
    OrderDetailTabBodyContainer,
    SalesDivAssignment,
    UndoDiv,
    Unassigned,
} from './ssa.styled';
// import {
//     CS_USER_ROLE,
//     DM_USER_ROLE,
//     FIA_USER_ROLE,
//     FIM_USER_ROLE,
//     RCM_USER_ROLE,
//     SM_USER_ROLE,
//     SOC_USER_ROLE,
// } from 'src/constants/appConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const SalesStructureAssignment = (props) => {
    const dispatch = useDispatch();

    const [selectedOption, setselectedOption] = useState('');
    const [salesStructures] = useState(props.salesHirerachy);
    const [selectedArea, setSelectedArea] = useState('');
    const [selectedRegion, setSelecteRegion] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [selectedSubDistrict, setSelectedSubDistrict] = useState('');
    const [selectedLevel4, setSelectedLevel4] = useState('');
    const [selectedTerritory, setSelectedTerritory] = useState('');
    // const [tempraryData, setTempraryData] = useState({});
    const [unsavedChange, setUnsavedChange] = useState(false);
    const [saveButton, setSaveButton] = useState(false);
    const [isDeleteOtherSales, setIsDeleteOtherSales] = useState(false);
    const [temprarySelectedIndex, setTemprarySelectedIndex] = useState([]);
    const [existingSelectedIndex, setExistingSelectedIndex] = useState([]);
    const [addButtonStatus, setAddButtonStatus] = useState(false);
    const [removeIds, setRemoveIds] = useState([]);
    const [unassignedCheck, setUnassignedCheck] = useState(false);
    // const [isNewAssignmentAdded, setIsNewAssignmentAdded] = useState(false);
    const [count, setCount] = useState(0);
    const [deleteCount, setdeleteCount] = useState(0);
    const [addParams, setAddParams] = useState([]);
    const [temAddErrorMsg, setTemAddErrorMsg] = useState(false);
    let params = {
        resource: 'area',
        area: selectedArea,
        region: selectedRegion,
        district: '',
        userId: props.userData && props.userData.userId,
        userRole: userRoleCodeForApi,
    };

    useEffectWithErrorLogging(() => {
        dispatch(getUserRoles());
        dispatch(getARDTlist(params, 'area'));
        return () => {
            dispatch(resetARDTList());
        };
    }, []);

    const newAssignmentStatusCode = useSelector(
        (state) => state.AdminReducer.newAssignmentStatusCode
    );
    const errorStatusMessage = useSelector(
        (state) => state.AdminReducer.errorStatusMessage
    );
    const area = useSelector((state) => state.AdminReducer.area);
    useEffectWithErrorLogging(() => {
        if (newAssignmentStatusCode === '10001') {
            const countValue = count + 1;
            setCount(countValue);
            setSaveButton(true);
        }
    }, [newAssignmentStatusCode]);

    const userRoles = useSelector((state) => state.AdminReducer.userRole);

    useEffectWithErrorLogging(() => {
        let currentUser =
            userRoles &&
            userRoles.filter(
                (e) => e.userRolesName === props.userData.userRoles[0]
            );

        let LoggedUserRole =
            currentUser && currentUser[0] && currentUser[0].userRolesCode;

        setselectedOption(LoggedUserRole);
    }, [userRoles]);
    const userRoleChange = useSelector(
        (state) => state.AdminReducer.userRoleChange
    );
    const areaList = useSelector((state) => state.AdminReducer.areaList);
    const regionList = useSelector((state) => state.AdminReducer.regionList);
    const districtList = useSelector(
        (state) => state.AdminReducer.districtList
    );
    const territoryList = useSelector(
        (state) => state.AdminReducer.territoryList
    );

    const subdistrictList = useSelector(
        (state) => state.AdminReducer.subdistrictList
    );

    const level4List = useSelector((state) => state.AdminReducer.level4List);

    const newAssignment = useSelector(
        (state) => state.AdminReducer.newAssignment
    );
    useEffectWithErrorLogging(() => {
        if (newAssignment.statusCode === '10001') {
            setSelectedArea('');
            setSelecteRegion('');
            setSelectedDistrict('');
            setSelectedTerritory('');
            setSelectedSubDistrict('');
        }
    }, [newAssignment.statusCode]);
    const options =
        userRoles &&
        userRoles.map((item) => {
            return {
                label: item.userRolesName,
                value: item.userRolesCode,
                className: 'customDropDownDesktop',
            };
        });

    const regionOptions =
        regionList &&
        regionList.map((item) => {
            return {
                label: item.name,
                value: item.id,
                className: 'customDropDownDesktop',
            };
        });

    const areaOptions =
        areaList &&
        areaList.map((item) => {
            return {
                label: item.name,
                value: item.id,
                className: 'customDropDownDesktop',
            };
        });
    // const blankDistrict = [
    //     {
    //         label: 'Blank District 000',
    //         value: '000',
    //         className: 'customDropDownForDistrict',
    //     },
    // ];
    const districtOptions =
        // props.userData.userRoles[0] === RCM_USER_ROLE
        //     ? blankDistrict
        //     :
        districtList &&
        districtList.map((item) => {
            return {
                label: item.name,
                value: item.id,
                className: 'customDropDownForDistrict',
            };
        });

    const subdistrictOptions =
        subdistrictList &&
        subdistrictList.map((item) => {
            return {
                label: item.name,

                value: item.id,
                className: 'customDropDownForDistrict',
            };
        });

    const level4Options =
        level4List &&
        level4List.map((item) => {
            return {
                label: item.name,

                value: item.id,
                className: 'customDropDownForDistrict',
            };
        });
    // const blankTerritoryCheck = [
    //     SM_USER_ROLE,
    //     DM_USER_ROLE,
    //     CS_USER_ROLE,
    //     RCM_USER_ROLE,
    //     FIM_USER_ROLE,
    //     FIA_USER_ROLE,
    //     SOC_USER_ROLE,
    // ];
    // const getTerritoryOptions = () => {
    //     let territoryData = [];
    //     // if (blankTerritoryCheck.includes(props.userData.userRoles[0])) {
    //     const blankTerritory = [{ id: '000', name: 'Blank Territory 000' }];
    //     territoryData =
    //         territoryList &&
    //         territoryList.length > 0 &&
    //         props.userData.userRoles[0] != RCM_USER_ROLE
    //             ? [...territoryList, ...blankTerritory]
    //             : blankTerritory;
    //     // } else {
    //     //     territoryData = [...territoryList];
    //     // }
    //     return territoryData.map((item) => {
    //         return {
    //             label: item.name,
    //             value: item.id,
    //             className: 'customDropDownForDistrict',
    //         };
    //     });
    // };
    const territoryOptions =
        // blankTerritoryCheck.includes(
        //     props.userData.userRoles[0]
        // )
        //     ? getTerritoryOptions()
        //     :
        territoryList &&
        territoryList.map((item) => {
            return {
                label: item.name,
                value: item.id,
                className: 'customDropDownForDistrict',
            };
        });

    let userRoleForApi =
        userRoles &&
        userRoles.filter(
            (e) => e.userRolesName === props.userData.userRoles[0]
        );

    let userRoleCodeForApi =
        userRoleForApi && userRoleForApi[0] && userRoleForApi[0].userRolesCode;

    useEffectWithErrorLogging(() => {
        if (regionOptions && regionOptions.length == 1) {
            handleRegionChange(regionOptions[0].value);
        }
    }, [regionList]);
    useEffectWithErrorLogging(() => {
        if (level4Options && level4Options.length == 1) {
            handleLevel4Change(level4Options[0].value);
        }
    }, [level4List]);
    useEffectWithErrorLogging(() => {
        if (territoryOptions && territoryOptions.length == 1) {
            handleTerritoryChange(territoryOptions[0].value);
        }
    }, [territoryList]);
    const handleChange = (selectedOption) => {
        let currentUser =
            userRoles &&
            userRoles.filter(
                (e) => e.userRolesName === props.userData.userRoles[0]
            );

        let LoggedUserRole =
            currentUser && currentUser[0] && currentUser[0].userRolesCode;
        if (selectedOption === 'UNASSIGNED') {
            setUnassignedCheck(true);
        } else {
            setUnassignedCheck(false);
            if (selectedOption !== LoggedUserRole) {
                setSaveButton(true);
            } else {
                setSaveButton(false);
            }
        }

        setselectedOption(selectedOption);
        setUnsavedChange(true);
        dispatch(setUserRolechange(selectedOption));
    };
    const handleAreaChange = (selectedOption) => {
        setSelectedArea(selectedOption);
        dispatch(setArea(selectedOption));
        setAddButtonStatus(false);

        let params = {
            resource: 'level1',
            area: selectedOption,
            region: '',
            district: '',
            userId: props.userData && props.userData.userId,
            userRole: userRoleCodeForApi,
        };
        setSelecteRegion('');
        setSelectedDistrict('');
        setSelectedTerritory('');
        setSelectedSubDistrict('');
        if (newAssignment && newAssignment.length === 0) {
            setSaveButton(false);
        }
        dispatch(getARDTlist(params, '', 'region'));
    };

    const handleRegionChange = (selectedOption) => {
        setSelecteRegion(selectedOption);
        let params = {
            resource: 'level2',
            area: selectedArea ? selectedArea : area,
            region: selectedOption,
            district: '',
            userId: props.userData && props.userData.userId,
            userRole: userRoleCodeForApi,
        };
        if (newAssignment && newAssignment.length === 0) {
            setSaveButton(false);
        }
        setAddButtonStatus(false);
        setSelectedDistrict('');
        setSelectedTerritory('');
        setSelectedSubDistrict('');
        // if (props.userData.userRoles[0] === RCM_USER_ROLE) {
        //     setSelectedDistrict('000');
        //     setSelectedTerritory('000');
        //     setAddButtonStatus(true);
        // } else {
        dispatch(getARDTlist(params, '', '', 'district'));
        // }
    };
    const handleDistrictChange = (selectedOption) => {
        setSelectedDistrict(selectedOption);
        // if (props.userData.userRoles[0] === 'MDT Spine SM') {
        let params = {
            resource: 'level3',
            area: selectedArea,
            region: selectedRegion,
            district: selectedOption,
            userId: props.userData && props.userData.userId,
            userRole: userRoleCodeForApi,
        };
        dispatch(getARDTlist(params, '', '', '', 'subDistrict'));

        if (newAssignment && newAssignment.length === 0) {
            setSaveButton(false);
        }
        setAddButtonStatus(false);
        setSelectedTerritory('');
        setSelectedSubDistrict('');
    };
    const handleSubDistrictChange = (selectedOption) => {
        setSelectedSubDistrict(selectedOption);
        let params = {
            resource: 'level4',
            area: selectedArea,
            region: selectedRegion,
            district: selectedDistrict,
            subDistrict: selectedOption,
            userId: props.userData && props.userData.userId,
            userRole: userRoleCodeForApi,
        };
        if (newAssignment && newAssignment.length === 0) {
            setSaveButton(false);
        }
        setAddButtonStatus(false);
        setSelectedLevel4('');
        dispatch(getARDTlist(params, '', '', '', '', '', 'level4'));
    };
    const handleLevel4Change = (selectedOption) => {
        if (selectedArea) {
            setSelectedLevel4(selectedOption);
            let params = {
                resource: 'territory',
                area: selectedArea,
                region: selectedRegion,
                district: selectedDistrict,
                subDistrict: selectedSubDistrict,
                level4: selectedOption,
                userId: props.userData && props.userData.userId,
                userRole: userRoleCodeForApi,
            };
            if (newAssignment && newAssignment.length === 0) {
                setSaveButton(false);
            }
            setAddButtonStatus(false);
            setSelectedTerritory('');
            dispatch(getARDTlist(params, '', '', '', '', 'territory'));
        }
    };
    const handleTerritoryChange = (selectedOption) => {
        setSelectedTerritory(selectedOption);
        // setSaveButton(true);
        setAddButtonStatus(true);
    };
    // const [onSave, setOnSave] = useState(false);
    // const [onCancel, setOnCancel] = useState(false);
    const { t } = useTranslation();
    // const [dropdownCode, setDropdownCode] = useState('ProductCode-asc');

    const onSave = () => {
        let params = {
            salesArea: selectedArea,
            region: selectedRegion,
            district: selectedDistrict,
            territory: selectedTerritory,
            subDistrict: selectedSubDistrict
                ? selectedSubDistrict
                : 'All_SubDistricts',
            userId: props.userData.userId,
            level4: selectedLevel4,
        };
        // const countValue = count + 1;
        // setCount(countValue);

        const tempAdd = [...addParams];
        const filteredarray = tempAdd.filter(
            (item) =>
                item.salesArea === params.salesArea &&
                item.region === params.region &&
                item.district === params.district &&
                item.subDistrict === params.subDistrict &&
                item.territory === params.territory &&
                item.level4==params.level4
        );
        if (filteredarray.length === 0) {
            setTemAddErrorMsg(false);
            tempAdd.push(params);
            setAddParams(tempAdd);
            // setTempraryData(params);
            dispatch(getNewAssignment(params));
        } else {
            setTemAddErrorMsg(true);
        }

        // setSaveButton(true);
        setAddButtonStatus(false);
        // setIsNewAssignmentAdded(true);
        setSelectedArea('');
        setSelecteRegion('');
        setSelectedDistrict('');
        setSelectedTerritory('');
        setSelectedSubDistrict('');
        setSelectedLevel4('');
    };
    const removeExistingOtherSales = (indexId, type, listData) => {
        const tempUndo = [...existingSelectedIndex];
        const idToremove = [...removeIds];
        setSaveButton(true);

        if (type === 'DELETE') {
            const countValue = deleteCount + 1;

            setdeleteCount(countValue);
            // setSaveButton(true);
            tempUndo.push(indexId);
            idToremove.push(listData.assignmentid);
        } else if (type === 'UNDO') {
            const index = tempUndo.findIndex((x) => x === indexId);
            if (index >= 0) {
                tempUndo.splice(index, 1);
            }
            const countValue = deleteCount - 1;

            setdeleteCount(countValue);
            if (countValue === 0 && count === 0) {
                setSaveButton(false);
            }
            // if (existingSelectedIndex.length === 1) {
            //     setSaveButton(false);
            // }
        }

        setExistingSelectedIndex(tempUndo);
        setRemoveIds(idToremove);
    };

    const removeOtherSales = (indexId, type) => {
        const tempUndo = [...temprarySelectedIndex];

        if (type === 'DELETE') {
            const countValue = count - 1;
            setCount(countValue);
            if (countValue === 0 && deleteCount === 0) {
                setSaveButton(false);
            }
            tempUndo.push(indexId);
        } else if (type === 'UNDO') {
            const index = tempUndo.findIndex((x) => x === indexId);
            if (index >= 0) {
                tempUndo.splice(index, 1);
            }
            const countUndoValue = count + 1;
            setCount(countUndoValue);
            if (countUndoValue !== 0) {
                setSaveButton(true);
            }
            // setIsNewAssignmentAdded(true);
            // setSaveButton(true);
        }
        setTemprarySelectedIndex(tempUndo);
    };

    const onSaveUpdateUser = () => {
        let currentUser = userRoles.filter(
            (e) => e.userRolesName === props.userData.userRoles[0]
        );
        setUnsavedChange(false);
        setIsDeleteOtherSales(false);
        let params;
        if (unsavedChange) {
            params = {
                currentUserRole: currentUser[0].userRolesCode,
                newUserRole: selectedOption,
                userId: props.userData.userId,
            };
        } else {
            params = {
                currentUserRole: currentUser[0].userRolesCode,
                newUserRole: currentUser[0].userRolesCode,
                userId: props.userData.userId,
            };
        }

        const updateExistingUserList =
            salesStructures &&
            salesStructures
                .filter(
                    (e) =>
                        e.otherSalesAssignment === true &&
                        removeIds.includes(e.assignmentid)
                )
                // .filter((e) => removeIds.includes(e.assignmentid))
                .map((value) => {
                    const { assignmentid } = value;
                    return {
                        assignmentId: assignmentid,
                        // operation: existingSelectedIndex.includes(indx)
                        //     ? 'Remove'
                        //     : 'Add',
                        operation: 'Remove',
                    };
                });
        const updateUserList = newAssignment
            .map((value, indx) => {
                const {
                    district,
                    region,
                    salesArea,
                    territory,
                    subDistrict,
                    level4,
                } = value;
                const isToBeDeleted = temprarySelectedIndex.includes(indx);
                if (isToBeDeleted) {
                    return null;
                }
                return {
                    level1: region,
                    level2: district,
                    level3: subDistrict,
                    level4: level4,
                    salesArea: salesArea,
                    territory: territory,
                    operation: temprarySelectedIndex.includes(indx)
                        ? 'Remove'
                        : 'Add',
                };
            })
            ?.filter((x) => x);

        params.userUpdateRequest = updateExistingUserList
            ? [...updateUserList, ...updateExistingUserList]
            : [...updateUserList];
        dispatch(updateUser(params));
        // let currentUser = userRoles.filter(
        //     (e) => e.userRolesName === props.userData.userRoles[0]
        // );
        // setUnsavedChange(false);
        // setIsDeleteOtherSales(false);
        // if (deleteSales) {
        //     let params = {
        //         currentUserRole: currentUser[0].userRolesCode,
        //         newUserRole: currentUser[0].userRolesCode,
        //         userId: props.userData.userId,
        //     };

        //     deleteSalesDetails.operation = 'Remove';

        //     let newParams = [].concat(deleteSalesDetails);
        //     params.userUpdateRequest = newParams;

        //     dispatch(updateUser(params));
        // } else if (Object.keys(tempraryData).length === 0) {
        //     let params = {
        //         currentUserRole: currentUser[0].userRolesCode,
        //         newUserRole: selectedOption,
        //         userId: props.userData.userId,
        //     };
        //     dispatch(updateUser(params));
        // } else {
        //     let params = {
        //         currentUserRole: currentUser[0].userRolesCode,
        //         newUserRole: selectedOption,
        //         userId: props.userData.userId,
        //     };

        //     tempraryData.operation = 'Add';

        //     let newParams = [].concat(tempraryData);
        //     params.userUpdateRequest = newParams;
        //     dispatch(clearNewAssignment());
        //     dispatch(updateUser(params));
        // }
        props.handleClose();
    };

    const roleCheck = [
        'MDT Spine CC',
        'MDT Spine FIM',
        'MDT Spine ITA',
        'MDT Spine SOC',
        'MDT Spine CSR',
        'Un-assigned',
        'MDT Spine SM',
        'MDT Spine FIA',
        'MDT Spine DCA',
        'MDT Spine SP',
    ];

    const assignmentCheck = [
        'MDT Spine CSR',
        'MDT Spine CC',
        'MDT Spine FIM',
        'MDT Spine ITA',
        'MDT Spine SP',
    ]; 
    return (
        <>
            <OrderDetailTabBodyContainer>
                <OrderDetailTabBody>
                    {userRoleChange === 'Un-assigned' && !unassignedCheck ? (
                        <Unassigned>
                            <img
                                src={AlertCircleOutline}
                                height="16px"
                                width="16px"
                                style={{ margin: '2px 6px 0 0' }}
                            />
                            <span>
                               {t('admin.nameDetails.userRoleChangeUnassignedMsg')}
                            </span>
                        </Unassigned>
                    ) : null}
                    {errorStatusMessage || temAddErrorMsg ? (
                        <Unassigned>
                            <span>
                                {t('admin.nameDetails.salesStructureAssignedtoUser')}
                            </span>
                        </Unassigned>
                    ) : null}
                    <Grid
                        container
                        justifyContent="space-between"
                        direction="row"
                    >
                        {(!assignmentCheck.includes(userRoleChange) &&
                            newAssignment.length > 0) ||
                        salesStructures != undefined ? (
                            <Grid item xs={12} sm={7} md={7} mobile={12}>
                                <DesktopView>
                                    <MainDiv>
                                        {salesStructures &&
                                        salesStructures.filter(
                                            (e) =>
                                                e.otherSalesAssignment === false
                                        ).length !== 0 ? (
                                            <Heading>
                                              {t('admin.nameDetails.salesStructureAssignment')}
                                            </Heading>
                                        ) : null}

                                        {salesStructures &&
                                            salesStructures

                                                .filter(
                                                    (e) =>
                                                        e.otherSalesAssignment ===
                                                        false
                                                )

                                                .map((listData, index) => {
                                                    return (
                                                        <SalesMainDiv
                                                            key={index}
                                                        >
                                                            <>
                                                                <SalesDiv>
                                                                    {(listData.jobFunctionCode
                                                                        ? listData.jobFunctionCode
                                                                        : '') +
                                                                        (listData.jobFunctionCode
                                                                            ? '-'
                                                                            : '') +
                                                                        listData.salesOrgName +
                                                                        '.' +
                                                                        listData.salesForceName +
                                                                        '.' +
                                                                        listData.structureName}{' '}
                                                                    <br></br>
                                                                    <span
                                                                        style={{
                                                                            color: '#00000',
                                                                            display:
                                                                                'inline-block',
                                                                            fontSize:
                                                                                '13px',
                                                                            fontFamily:
                                                                                'AvenirNextWorld Demi',
                                                                        }}
                                                                    >
                                                                        {
                                                                            listData.districtName
                                                                        }{' '}
                                                                        {listData.territoryName
                                                                            ? '  •  '
                                                                            : ''}
                                                                        <span
                                                                            style={{
                                                                                fontFamily:
                                                                                    'AvenirNextWorld Regular',
                                                                            }}
                                                                        >
                                                                            {
                                                                                listData.territoryName
                                                                            }
                                                                        </span>
                                                                    </span>
                                                                </SalesDiv>

                                                                <ImgDiv>
                                                                    <img
                                                                        src={
                                                                            Lock
                                                                        }
                                                                        alt={
                                                                            'lock'
                                                                        }
                                                                        width={
                                                                            'auto'
                                                                        }
                                                                        height={
                                                                            'auto'
                                                                        }
                                                                    />
                                                                </ImgDiv>
                                                            </>
                                                        </SalesMainDiv>
                                                    );
                                                })}

                                        {salesStructures &&
                                        salesStructures.filter(
                                            (e) =>
                                                e.otherSalesAssignment === true
                                        ).length !== 0 ? (
                                            <Heading
                                                style={{ marginBottom: '10px' }}
                                            >
                                                {' '}
                                               {t('admin.nameDetails.otherSalesAssignments')}
                                            </Heading>
                                        ) : null}

                                        {salesStructures &&
                                            salesStructures

                                                .filter(
                                                    (e) =>
                                                        e.otherSalesAssignment ===
                                                        true
                                                )

                                                .map((listData, index) => {
                                                    return (
                                                        <SalesMainDiv
                                                            key={index}
                                                        >
                                                            <SalesDiv
                                                                strikeThru={existingSelectedIndex.includes(
                                                                    index
                                                                )}
                                                            >
                                                                {(listData.jobFunctionCode
                                                                    ? listData.jobFunctionCode
                                                                    : '') +
                                                                    (listData.jobFunctionCode
                                                                        ? '-'
                                                                        : '') +
                                                                    listData.salesOrgName +
                                                                    '.' +
                                                                    listData.salesForceName +
                                                                    '.' +
                                                                    listData.structureName}{' '}
                                                                <br></br>
                                                                <span
                                                                    style={{
                                                                        textDecoration:
                                                                            existingSelectedIndex.includes(
                                                                                index
                                                                            )
                                                                                ? 'line-through'
                                                                                : 'unset',
                                                                        color: '#00000',
                                                                        display:
                                                                            'inline-block',
                                                                        fontSize:
                                                                            '13px',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Demi',
                                                                    }}
                                                                >
                                                                    {
                                                                        listData.districtName
                                                                    }
                                                                </span>
                                                                {listData.territoryName
                                                                    ? '  •  '
                                                                    : ''}
                                                                <span
                                                                    style={{
                                                                        fontFamily:
                                                                            'AvenirNextWorld Regular',
                                                                    }}
                                                                >
                                                                    {
                                                                        listData.territoryName
                                                                    }
                                                                </span>
                                                            </SalesDiv>
                                                            {existingSelectedIndex.includes(
                                                                index
                                                            ) ? (
                                                                <UndoDiv
                                                                    id={`admin-ssa-nameDetails-undoButton-${index}`}
                                                                    onClick={() => {
                                                                        try {
                                                                            removeExistingOtherSales(
                                                                                index,
                                                                                'UNDO',
                                                                                listData
                                                                            );
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                >
                                                                   {t('admin.nameDetails.undo')}
                                                                </UndoDiv>
                                                            ) : (
                                                                <ImgDiv>
                                                                    <img
                                                                        id={`admin-ssa-nameDetails-deleteButton-${index}`}
                                                                        src={
                                                                            DeleteLight
                                                                        }
                                                                        alt={
                                                                            'lock'
                                                                        }
                                                                        width={
                                                                            'auto'
                                                                        }
                                                                        height={
                                                                            'auto'
                                                                        }
                                                                        onClick={() => {
                                                                            try {
                                                                                removeExistingOtherSales(
                                                                                    index,
                                                                                    'DELETE',
                                                                                    listData
                                                                                );
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                    />
                                                                </ImgDiv>
                                                            )}
                                                        </SalesMainDiv>
                                                    );
                                                })}

                                        {newAssignment.length > 0 ? (
                                            <>
                                                {(salesStructures &&
                                                    salesStructures.filter(
                                                        (e) =>
                                                            e.otherSalesAssignment ===
                                                            true
                                                    ).length === 0) ||
                                                salesStructures ===
                                                    undefined ? (
                                                    <Heading
                                                        style={{
                                                            marginBottom:
                                                                '10px',
                                                        }}
                                                    >
                                                        {' '}
                                                       {t('admin.nameDetails.otherSalesAssignments')}
                                                    </Heading>
                                                ) : null}
                                                {newAssignment.map(
                                                    (value, indx) => {
                                                        return (
                                                            <SalesMainDiv
                                                                key={indx}
                                                            >
                                                                <SalesDivAssignment
                                                                    strikeThru={temprarySelectedIndex.includes(
                                                                        indx
                                                                    )}
                                                                >
                                                                    <div>
                                                                        {
                                                                            value.salesHierarchy
                                                                        }
                                                                    </div>{' '}
                                                                    <span
                                                                        style={{
                                                                            textDecoration:
                                                                                temprarySelectedIndex.includes(
                                                                                    indx
                                                                                )
                                                                                    ? 'line-through'
                                                                                    : 'unset',
                                                                            color: '#00000',
                                                                            display:
                                                                                'inline-block',
                                                                            fontSize:
                                                                                '13px',
                                                                            fontFamily:
                                                                                'AvenirNextWorld Demi',
                                                                        }}
                                                                    >
                                                                        {
                                                                            value.districtName
                                                                        }
                                                                    </span>
                                                                    {value.territoyName
                                                                        ? '  •  '
                                                                        : ''}
                                                                    {
                                                                        value.territoyName
                                                                    }
                                                                </SalesDivAssignment>
                                                                {temprarySelectedIndex.includes(
                                                                    indx
                                                                ) ? (
                                                                    <UndoDiv
                                                                        id={`admin-ssa-nameDetails-undoButton-newAssignment-${indx}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                removeOtherSales(
                                                                                    indx,
                                                                                    'UNDO'
                                                                                );
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {t('admin.nameDetails.undo')}
                                                                    </UndoDiv>
                                                                ) : (
                                                                    <ImgDiv
                                                                        id={`admin-ssa-nameDetails-deleteButton-newAssignment-${indx}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                removeOtherSales(
                                                                                    indx,
                                                                                    'DELETE'
                                                                                );
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                DeleteLight
                                                                            }
                                                                            alt={
                                                                                'lock'
                                                                            }
                                                                            width={
                                                                                'auto'
                                                                            }
                                                                            height={
                                                                                'auto'
                                                                            }
                                                                        />
                                                                    </ImgDiv>
                                                                )}
                                                            </SalesMainDiv>
                                                        );
                                                    }
                                                )}
                                            </>
                                        ) : null}
                                    </MainDiv>
                                </DesktopView>
                            </Grid>
                        ) : null}
                        <Grid
                            item
                            xs={12}
                            sm={5}
                            md={5}
                            mobile={12}
                            style={{ paddingBottom: '200px' }}
                        >
                            {roleCheck.includes(userRoleChange) ||
                            unsavedChange ||
                            (salesStructures &&
                                salesStructures.filter(
                                    (e) => e.otherSalesAssignment === true
                                ).length > 0) ||
                            salesStructures === undefined ? (
                                <MainDiv>
                                    <RoleBox>
                                        <SubHeading className="role">
                                           {t('admin.nameDetails.role')}{' '}
                                        </SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-selectuser"
                                                scrollHeight={'215px'}
                                                // placeholder={t(
                                                //     'proxies.addAProxy.selectuser'
                                                // )}
                                                labelColor={'#202124'}
                                                options={options}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedOption}
                                                onChange={handleChange}
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </RoleBox>
                                </MainDiv>
                            ) : (
                                <MainDiv>
                                    <RoleBox>
                                        <SubHeading className="role">
                                        {t('admin.nameDetails.role')}
                                        </SubHeading>
                                        <Container2>
                                            {userRoleChange}
                                        </Container2>
                                    </RoleBox>
                                </MainDiv>
                            )}

                            <OrderSalesMobile>
                                <MainDiv>
                                    {salesStructures &&
                                    salesStructures.filter(
                                        (e) => e.otherSalesAssignment === false
                                    ).length !== 0 ? (
                                        <Heading>
                                            {t('admin.nameDetails.salesStructureAssignment')}
                                        </Heading>
                                    ) : null}

                                    {salesStructures &&
                                        salesStructures

                                            .filter(
                                                (e) =>
                                                    e.otherSalesAssignment ===
                                                    false
                                            )

                                            .map((listData, index) => {
                                                return (
                                                    <SalesMainDiv key={index}>
                                                        <>
                                                            <SalesDiv>
                                                                {(listData.jobFunctionCode
                                                                    ? listData.jobFunctionCode
                                                                    : '') +
                                                                    (listData.jobFunctionCode
                                                                        ? '-'
                                                                        : '') +
                                                                    listData.salesOrgName +
                                                                    '.' +
                                                                    listData.salesForceName +
                                                                    '.' +
                                                                    listData.structureName}
                                                                {''}

                                                                <br></br>
                                                                <span
                                                                    style={{
                                                                        color: '#00000',
                                                                        display:
                                                                            'inline-block',
                                                                        fontSize:
                                                                            '13px',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Demi',
                                                                    }}
                                                                >
                                                                    {
                                                                        listData.districtName
                                                                    }{' '}
                                                                    {listData.territoryName
                                                                        ? '  •  '
                                                                        : ''}
                                                                    {
                                                                        listData.territoryName
                                                                    }
                                                                </span>
                                                            </SalesDiv>

                                                            <ImgDiv>
                                                                <img
                                                                    src={Lock}
                                                                    alt={'lock'}
                                                                    width={
                                                                        'auto'
                                                                    }
                                                                    height={
                                                                        'auto'
                                                                    }
                                                                />
                                                            </ImgDiv>
                                                        </>
                                                    </SalesMainDiv>
                                                );
                                            })}

                                    {salesStructures &&
                                    salesStructures.filter(
                                        (e) => e.otherSalesAssignment === true
                                    ).length !== 0 ? (
                                        <Heading className="otherSalesAssignments">
                                            {' '}
                                            {t('admin.nameDetails.otherSalesAssignments')}
                                        </Heading>
                                    ) : null}

                                    {salesStructures &&
                                        salesStructures
                                            .filter(
                                                (e) =>
                                                    e.otherSalesAssignment ===
                                                    true
                                            )
                                            .map((listData, index) => {
                                                return (
                                                    <SalesMainDiv
                                                        key={index}
                                                        className="otherSalesDiv"
                                                    >
                                                        <SalesDiv
                                                            strikeThru={existingSelectedIndex.includes(
                                                                index
                                                            )}
                                                        >
                                                            {(listData.jobFunctionCode
                                                                ? listData.jobFunctionCode
                                                                : '') +
                                                                (listData.jobFunctionCode
                                                                    ? '-'
                                                                    : '') +
                                                                listData.salesOrgName +
                                                                '.' +
                                                                listData.salesForceName +
                                                                '.' +
                                                                listData.structureName}{' '}
                                                            <span
                                                                style={{
                                                                    textDecoration:
                                                                        existingSelectedIndex.includes(
                                                                            index
                                                                        )
                                                                            ? 'line-through'
                                                                            : 'unset',
                                                                    display:
                                                                        'inline-block',
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        color: '#00000',
                                                                        fontSize:
                                                                            '13px',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Demi',
                                                                        // marginLeft:
                                                                        //     index ===
                                                                        //     2
                                                                        //         ? '-190px'
                                                                        //         : '0px',
                                                                    }}
                                                                >
                                                                    {
                                                                        listData.districtName
                                                                    }
                                                                    {listData.territoryName
                                                                        ? '  •  '
                                                                        : ''}
                                                                </span>
                                                                <br />
                                                                <span
                                                                    style={{
                                                                        fontFamily:
                                                                            'AvenirNextWorld Regular',
                                                                    }}
                                                                >
                                                                    {
                                                                        listData.territoryName
                                                                    }
                                                                </span>
                                                            </span>
                                                        </SalesDiv>
                                                        {existingSelectedIndex.includes(
                                                            index
                                                        ) ? (
                                                            <UndoDiv
                                                                id={`admin-ssa-nameDetails-undoButton-${index}`}
                                                                onClick={() => {
                                                                    try {
                                                                        removeExistingOtherSales(
                                                                            index,
                                                                            'UNDO',
                                                                            listData
                                                                        );
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                            >
                                                                {t('admin.nameDetails.undo')}
                                                            </UndoDiv>
                                                        ) : (
                                                            <ImgDiv>
                                                                <img
                                                                    id={`admin-ssa-nameDetails-deleteButton-${index}`}
                                                                    src={
                                                                        DeleteLight
                                                                    }
                                                                    alt={'lock'}
                                                                    width={
                                                                        'auto'
                                                                    }
                                                                    height={
                                                                        'auto'
                                                                    }
                                                                    onClick={() => {
                                                                        try {
                                                                            removeExistingOtherSales(
                                                                                index,
                                                                                'DELETE',
                                                                                listData
                                                                            );
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                />
                                                            </ImgDiv>
                                                        )}
                                                    </SalesMainDiv>
                                                );
                                            })}
                                    {newAssignment.length !== 0 ? (
                                        <>
                                            {salesStructures &&
                                            salesStructures.filter(
                                                (e) =>
                                                    e.otherSalesAssignment ===
                                                    true
                                            ).length === 0 ? (
                                                <Heading className="otherSalesAssignments">
                                                    {' '}
                                                    {t('admin.nameDetails.otherSalesAssignments')}
                                                </Heading>
                                            ) : null}
                                            {newAssignment.map(
                                                (value, indx) => {
                                                    return (
                                                        <SalesMainDiv
                                                            key={indx}
                                                        >
                                                            <SalesDivAssignment
                                                                strikeThru={temprarySelectedIndex.includes(
                                                                    indx
                                                                )}
                                                            >
                                                                {
                                                                    value.salesHierarchy
                                                                }
                                                                <span
                                                                    style={{
                                                                        textDecoration:
                                                                            temprarySelectedIndex.includes(
                                                                                indx
                                                                            )
                                                                                ? 'line-through'
                                                                                : 'unset',
                                                                        color: '#00000',
                                                                        display:
                                                                            'inline-block',
                                                                        fontSize:
                                                                            '13px',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Demi',
                                                                    }}
                                                                >
                                                                    {
                                                                        value.districtName
                                                                    }
                                                                </span>
                                                                {value.territoyName
                                                                    ? '  •  '
                                                                    : ''}
                                                                {
                                                                    value.territoyName
                                                                }
                                                            </SalesDivAssignment>
                                                            {temprarySelectedIndex.includes(
                                                                indx
                                                            ) ? (
                                                                <UndoDiv
                                                                    id={`admin-ssa-nameDetails-undoButton-newAssignment-${indx}`}
                                                                    onClick={() => {
                                                                        try {
                                                                            removeOtherSales(
                                                                                indx,
                                                                                'UNDO'
                                                                            );
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                >
                                                                   {t('admin.nameDetails.undo')}
                                                                </UndoDiv>
                                                            ) : (
                                                                <ImgDiv
                                                                    id="admin-ssa-nameDetails-deleteButton-newAssignment"
                                                                    onClick={() => {
                                                                        try {
                                                                            removeOtherSales(
                                                                                indx,
                                                                                'DELETE'
                                                                            );
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            DeleteLight
                                                                        }
                                                                        alt={
                                                                            'lock'
                                                                        }
                                                                        width={
                                                                            'auto'
                                                                        }
                                                                        height={
                                                                            'auto'
                                                                        }
                                                                    />
                                                                </ImgDiv>
                                                            )}
                                                        </SalesMainDiv>
                                                    );
                                                }
                                            )}
                                        </>
                                    ) : null}
                                </MainDiv>
                            </OrderSalesMobile>
                            {assignmentCheck.includes(userRoleChange) ? null : (
                                <MainDiv>
                                    <Heading>{t('admin.nameDetails.addNewAssignment')}</Heading>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.area')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-area"
                                                placeholder={t(
                                                    'admin.ssa.area'
                                                )}
                                                labelColor={'#202124'}
                                                options={areaOptions}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedArea}
                                                onChange={handleAreaChange}
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.level1')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-region"
                                                placeholder={t(
                                                    'admin.ssa.region'
                                                )}
                                                labelColor={'#202124'}
                                                options={regionOptions}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedRegion}
                                                onChange={handleRegionChange}
                                                disabled={
                                                    selectedArea ? false : true
                                                }
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.level2')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-district"
                                                placeholder={t(
                                                    'admin.ssa.district'
                                                )}
                                                labelColor={'#202124'}
                                                options={districtOptions}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedDistrict}
                                                onChange={handleDistrictChange}
                                                disabled={
                                                    selectedRegion
                                                        ? false
                                                        : true
                                                }
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.level3')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-subdistrict"
                                                placeholder={t(
                                                    'admin.ssa.subdistrict'
                                                )}
                                                labelColor={'#202124'}
                                                options={subdistrictOptions}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedSubDistrict}
                                                onChange={
                                                    handleSubDistrictChange
                                                }
                                                disabled={
                                                    selectedDistrict
                                                        ? false
                                                        : true
                                                }
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.level4')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-level4"
                                                placeholder={t(
                                                    'admin.ssa.level4'
                                                )}
                                                labelColor={'#202124'}
                                                options={level4Options}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedLevel4}
                                                onChange={handleLevel4Change}
                                                disabled={
                                                    selectedSubDistrict
                                                        ? false
                                                        : true
                                                }
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <Box>
                                        <SubHeading>{t('admin.nameDetails.territory')}</SubHeading>
                                        <Container2>
                                            <Select
                                                id="admin-ssa-nameDetails-territory"
                                                placeholder={t(
                                                    'admin.ssa.territory'
                                                )}
                                                labelColor={'#202124'}
                                                options={territoryOptions}
                                                // itemTemplate={selectedUserItemTemplate}
                                                value={selectedTerritory}
                                                onChange={handleTerritoryChange}
                                                disabled={
                                                    selectedLevel4
                                                        ? false
                                                        : true
                                                }
                                                selectedLabelFontSize={'14px'}
                                            />
                                        </Container2>
                                    </Box>
                                    <ButtonDiv>
                                        <Button
                                           id={'pages-admin-ssa-nameDetails-addButton'}
                                            show={true}
                                            // secondary={!addButtonStatus}
                                            // disabledSaveBtn={!addButtonStatus}
                                            disabled={!addButtonStatus}
                                            // primary={addButtonStatus}
                                            variant={addButtonStatus ? ButtonStyles.primary : ButtonStyles.secondaryGreyBorder}
                                            width={'131px'}
                                            mobileWidth={'160px'}
                                            height={'38px'}
                                            //border={'1px solid #9A9A9A'}
                                            clicked={onSave}
                                        >
                                            <TextBold
                                                color={
                                                    addButtonStatus
                                                        ? '#FFFFFF'
                                                        : '#9A9A9A'
                                                }
                                            >
                                            {t('admin.nameDetails.add')}
                                            </TextBold>
                                        </Button>
                                    </ButtonDiv>
                                </MainDiv>
                            )}
                        </Grid>
                    </Grid>
                </OrderDetailTabBody>
            </OrderDetailTabBodyContainer>
            <BottomNavigation
                opacity={'1'}
                border={'1px solid #1010EB'}
                position={'absolute'}
                padding={'11px 33px !important'}
                mbPadding={'11px 10px !important'}
                justifyContent={'flex-end'}
                moblieJustifyContent={'center'}
                bottom={'0'}
                left={'0'}
                right={'0'}
                smalDeviceJustifyContent={'center'}
                //portraitposition={'fixed'}
            >
                <Button
                    id={'page-admin-impersonate-cancel'}
                    show={true}
                    //secondary={true}
                    // btnlook-001
                    variant={ButtonStyles.secondary}
                    border={'1px solid #140F4B'}
                    top={'659px'}
                    left={'670px'}
                    width={'131px'}
                    mobileWidth={'160px'}
                    height={'38px'}
                    margin={
                        window.innerWidth <= sizes.mobileDevice
                            ? '0px 6px 0px 0px'
                            : '0px 20px 0px 0'
                    }
                    clicked={props.handleClose}
                >
                    <TextBold color={'#140F4B'}>
                    {t('admin.impersonate.cancel')}
                    </TextBold>
                </Button>

                <Button
                    // disabledSaveBtn={
                    //     saveButton || isDeleteOtherSales
                    //         ? // || isNewAssignmentAdded
                    //           false
                    //         : true
                    // }
                    // disabledSaveBtn={
                    //     !saveButton ||
                    //     (unassignedCheck && !addButtonStatus) ||
                    //     isDeleteOtherSales
                    // }
                    //disabled
                    disabled={
                        saveButton || isDeleteOtherSales
                            ? // || isNewAssignmentAdded
                              false
                            : true
                    }
                    // disabled={
                    //     (!saveButton && !isDeleteOtherSales) ||
                    //     (unassignedCheck && !addButtonStatus)
                    // }
                    // primary={
                    //     // isNewAssignmentAdded
                    //     //     ? isNewAssignmentAdded
                    //     //     :
                    //     saveButton
                    //         ? saveButton
                    //         : isDeleteOtherSales
                    //         ? isDeleteOtherSales
                    //         : false
                    // }
                    id={'page-admin-impersonate-save'}
                    variant={(saveButton || isDeleteOtherSales) ? ButtonStyles.primary : ButtonStyles.disabled}
                    show={true}
                    // primary={true}
                    top={'659px'}
                    left={'670px'}
                    width={'131px'}
                    mobileWidth={'160px'}
                    height={'38px'}
                    clicked={onSaveUpdateUser}
                >
                    <TextBold color={'#FFFFFF'}>
                        {t('accounts.shipToAddress.save')}
                    </TextBold>
                </Button>
            </BottomNavigation>
        </>
    );
};

export default SalesStructureAssignment;
